module.exports = __webpack_public_path__ + "img/06.1f2e5397.jpg";